import React from 'react';
import PropTypes from 'prop-types';

export const Keep = ({ width, height, ...props }) => (
  <svg
    data-icon='keep'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m16 12 2 2v2h-5v6l-1 1-1-1v-6H6v-2l2-2V5H7V3h10v2h-1v7Zm-7.15 2h6.3L14 12.85V5h-4v7.85L8.85 14Z'
    />
  </svg>
);

Keep.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Keep.defaultProps = {
  width: 24,
  height: 24,
};
